<template>
    <div>
        <div class="flex vertical-center center-horizontal" v-if="status_provision === 'provisioned' && column === 'Action'">
            <vx-tooltip text="Unpairing device" position="top">
                <vs-button size="small" icon-pack="feather" icon="icon-maximize-2" @click="unpairRecord" color="dark" class="mr-2"></vs-button>
            </vx-tooltip>
        </div>
        <div class="flex vertical-center center-horizontal" v-if="column === 'Status Provision' && status_provision !== ''">
            <vs-chip class="line-0" v-bind:color="getColorStatusProvision(status_provision)">
                {{ status_provision }}
            </vs-chip>
        </div>
        <div class="flex vertical-center center-horizontal" v-if="column === 'Status Device' && status_device !== ''">
            <vs-chip class="line-0" v-bind:color="getColorStatusActive(status_device)">
                {{ status_device }}
            </vs-chip>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    export default Vue.extend({
        name: "ActionTableAgGridComponent",
        data() {
            return {
                status_provision: "",
                column:"",
                status_device:"",
                payment_acceptance: []
            }
        },
        methods: {
            unpairRecord() {
                this.$root.$emit("unpair-from-ActionTableAgGridComponent", this.params.value)
            },
            getColorStatusProvision(status){
                if (status === "provisioned") return "success"
                if (status === "not provisioned") return "warning"
            },
            getColorStatusActive(status){
                if (status === "active") return "success"
                if (status === "not active") return "warning"
            }
        },
        created() {
            this.status_provision = (this.params.data.status_provision === null) ? "":this.params.data.status_provision
            this.column = this.params.colDef.headerName
            this.status_device = (this.params.data.status_device === null) ? "" : this.params.data.status_device
            if (this.column === 'Payment Acceptance'){
                this.payment_acceptance = this.params.value
            }
        },
        mounted(){
            this.status_provision = (this.params.data.status_provision === null) ? "":this.params.data.status_provision
            this.column = this.params.colDef.headerName
            this.status_device = (this.params.data.status_device === null) ? "" : this.params.data.status_device
            if (this.column === 'Payment Acceptance'){
                this.payment_acceptance = this.params.value
            }
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .line-0 {
        line-height: 0;
    }
    .center-horizontal{
        margin-left: -20% !important;
    }
</style>